<template>
  <el-tooltip effect="dark" placement="left" :content="tooltipContent">
    <div class="ctrl-100">
      <el-button
        class="ctrl-btn"
        @click="toggleHelp"
        type="text"
        @mouseenter.native="resetRequest"
      >
        <IconBase
          :height="32"
          :width="32"
          :fill="helpRequested() ? '#50C6DF' : '#E7E6FA'"
          :viewBox="'0 0 32 32'"
          class="ctrl-icon"
        >
          <IconHelp />
        </IconBase>
        <span :class="{ active: helpRequested() }">Ask help </span>
      </el-button>
    </div>
  </el-tooltip>
</template>

<script>
import Icon from "vue-awesome/components/Icon";
import IconBase from "../IconBase";
import IconHelp from "../icons/IconHelp";

import { mapState, mapGetters } from "vuex";
import { getSocketPayload } from "../../utils";

export default {
  name: "NeedHelp",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Icon,
    IconBase,
    IconHelp
  },

  data() {
    return {
      requestSent: false,
      requestState: null,
      requestStates: {
        SENT: "SENT",
        WITHDRAWN: "WITHDRAWN"
      }
    };
  },

  methods: {
    toggleHelp() {
      const prevState = this.helpRequested();
      this.socket.emit(
        "UPDATE_ROOM",
        getSocketPayload({
          event: "NEED_HELP",
          token: this.tokens ? this.tokens["idToken"] : null,
          mainRoom: this.mainRoom.name,
          needHelp: !prevState
        })
      );
      this.requestSent = true;
      this.requestState = prevState
        ? this.requestStates.WITHDRAWN
        : this.requestStates.SENT;
    },
    resetRequest() {
      this.requestSent = false;
      this.requestState = null;
    }
  },
  computed: {
    ...mapState({
      currentRoom: state => state.rooms.currentRoom,
      mainRoom: state => state.rooms.mainRoom,
      tokens: state => state.user.tokens
    }),
    ...mapGetters("rooms", {
      socket: "getSocket",
      isNeedHelp: "getNeedHelp"
    }),

    helpRequested: function() {
      return () => this.isNeedHelp(this.currentRoom._id);
    },

    tooltipContent: function() {
      if (this.requestSent)
        return this.requestState === this.requestStates.SENT
          ? "Request Sent!"
          : "Request withdrawn";
      else if (this.helpRequested()) return "Withdraw request";
      return "Request help";
    }
  }
};
</script>

<style scoped>
.need-help {
  fill: #f7f7f7;
}

.need-help:hover,
.need-help-active {
  fill: #409eff;
}
.ctrl-icon {
  display: block;
}

span.active {
  color: #50c6df;
}

button.ctrl-btn.el-button:hover span.active,
button.ctrl-btn.el-button.active span.active {
  color: #1c1c29;
}
</style>
